// extracted by mini-css-extract-plugin
export var adjacentSlide = "_o0-9";
export var arrowButtonContainer = "_o0-5";
export var arrowButtonIcon = "_o0-6";
export var carouselArrowButton = "_o0-2";
export var carouselElementContainer = "_o0-1";
export var currentSlide = "_o0-8";
export var left = "_o0-3";
export var otherSlide = "_o0-a";
export var productCarouselContainer = "_o0-0";
export var right = "_o0-4";
export var sliderOverflow = "_o0-7";